import React from "react";

const EsemieLoaderLogo = () => {
    return (
        <>
            <svg width="49" height="38" viewBox="0 0 49 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M31.6839 28.6655C29.5612 35.5176 21.8075 37.2306 18.196 37.2306C22.8394 34.9766 25.2716 18.9735 25.7139 17.1703C26.1561 15.3671 27.925 2.51951 33.895 0.490936C38.6711 -1.13192 45.4666 4.32268 48.2674 7.25284C45.0609 4.60837 39.6219 4.0046 37.6539 6.57665C35.7212 9.10268 34.3373 20.1005 31.6839 28.6655Z" fill="#044E97" />
                <path d="M16.5835 8.56507C18.7061 1.71301 26.4598 -6.42616e-07 30.0713 0C25.428 2.25397 22.9957 18.2571 22.5535 20.0603C22.1113 21.8635 20.3424 34.7111 14.3723 36.7397C9.59629 38.3625 2.80076 32.9079 0 29.9778C3.2065 32.6222 8.64548 33.226 10.6134 30.654C12.5461 28.1279 13.9301 17.1301 16.5835 8.56507Z" fill="#FF6702" />
            </svg>

        </>
    );
};

export default EsemieLoaderLogo;
